import React from 'react';
import type { Level, TeaserPatient } from '../../data/teaser';
type PatientCardProps = {
  patient: TeaserPatient;
};
export function PatientCard({
  patient
}: PatientCardProps) {
  return <figure className="flex min-w-0 flex-col" data-id="element-786" data-mp="2dhvawnkikg71">
      <div className="overflow-hidden rounded-2xl bg-wash" data-id="element-787" data-mp="2dioexgs38rlh">
        <img src={patient.image} alt={`${patient.label} portrait`} className="aspect-[5/6] w-full object-cover object-top grayscale-[35%]" data-id="element-788" data-mp="28jtp3uvpe2rv" />
      </div>
      <figcaption className="mt-3" data-id="element-789" data-mp="3177e96t5tu1f">
        <p className="text-[13px] font-semibold text-ink" data-id="element-790" data-mp="3190p6yat30f8">{patient.label}</p>
        <dl className="mt-2 space-y-1.5" data-id="element-791" data-mp="2wg7hc1k1jbyx">
          <Row label="AMH" text={patient.amh.text} level={patient.amh.level} data-id="element-792" data-mp="2wewdy2uic68c" />
          <Row label="Weight" text={patient.weight.text} level={patient.weight.level} data-id="element-793" data-mp="2rhefj6e499el" />
        </dl>
      </figcaption>
    </figure>;
}
function Row({
  label,
  text,
  level
}: {
  label: string;
  text: string;
  level: Level;
}) {
  return <div className="flex items-center justify-between gap-2 border-t border-ink/10 pt-1.5" data-id="element-794" data-mp="3k4qp8fz6hmqh">
      <dt className="font-mono text-[10px] tracking-[0.12em] text-graphite" data-id="element-795" data-mp="3ejb7bie3mt0z">{label.toUpperCase()}</dt>
      <dd className="flex items-center gap-2 text-[12px] font-medium text-ink" data-id="element-796" data-mp="3jhw9vogtposl">
        {text}
        <span className="flex items-end gap-[2px]" aria-hidden="true" data-id="element-797" data-mp="35mu6p93d2djh">
          {[1, 2, 3].map(i => <span key={i} className={`w-[3px] rounded-full ${i <= level ? 'bg-ink' : 'bg-ink/15'}`} style={{
          height: 4 + i * 3
        }} data-id="element-798" data-mp="39nvzb72rvrch" />)}
        </span>
      </dd>
    </div>;
}